import {useEffect, useState} from 'react'
import apiClient from 'src/services/apiClient'
// eslint-disable-next-line no-restricted-imports
import PasswordRecoveryPage from 'src/pages/passwordRecovery/PasswordRecoveryPage'
import PasswordRecoveryPageNew from './PasswordRecoveryPageNew'
import ThemeProviderNew from 'src/theme-new/ThemeProviderNew'

const PasswordRecoveryGate = () => {
  const [config, setConfig] = useState<any>()

  useEffect(() => {
    let mounted = true
    apiClient.loginConfiguration().then((res: any) => {
      if (mounted) setConfig(res)
    })
    return () => { mounted = false }
  }, [])

  if (!config) return null

  if (config.newStyleEnabled) {
    return (
      <ThemeProviderNew themeOverride={{primaryColor: config.primaryColor}}>
        <PasswordRecoveryPageNew config={config} />
      </ThemeProviderNew>
    )
  }

  return <PasswordRecoveryPage />
}

export default PasswordRecoveryGate
